module.exports = __webpack_public_path__ + "static/media/chip-5500.31d0702a.png";